// extracted by mini-css-extract-plugin
export default {"container":"QualityPolicyPage_container__9GsAd"};